<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <ion-button (click)="goBack()" *ngIf="!showThankYouMessage">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title
      *ngIf="currentQuestionDetails.surveyLength && !showThankYouMessage"
      [innerHtml]="'SURVEY.question.totalNumber' | translate:{
        questionNumber: (currentQuestionDetails.currentIndex + 1),
        totalNumberOfQuestions: currentQuestionDetails.surveyLength
      }"
    ></ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false" class="ion-content--thank-you" *ngIf="showThankYouMessage">
  <div class="ion-content__background">
    <p class="title">{{ 'SHARED.thanks' | translate }}</p>
    <p>{{ 'SURVEY.thankYou.p' | translate }}</p>
    <ion-button expand="block" mode="ios" (click)="dismiss()">{{'ACCOUNT.redeem.close' | translate}}</ion-button>
  </div>
</ion-content>
<ion-content [scrollY]="true" *ngIf="currentQuestion && !showThankYouMessage">
  <div class="superhuman__stepper">
    <div
      class="superhuman__stepper-item"
      *ngFor="let item of stepperArray"
      [class.superhuman__stepper-item--active]="item <= currentQuestionDetails.currentIndex"
    ></div>
  </div>
  <ion-label>{{ 'SURVEY.question.number' | translate:{ number: currentQuestionDetails.currentIndex + 1 } }}</ion-label>
  <ion-label class="superhuman__question-title">{{ currentQuestion.question_text }}</ion-label>
  <!-- Survey options -->
  <div [ngSwitch]="currentQuestionDetails?.question?.type">
    <!-- Free text -->
    <div *ngSwitchDefault>
      <form [formGroup]="freeTextFrom">
        <ion-item class="item-input item-interactive item-textarea">
          <ion-textarea [placeholder]="'SURVEY.question.placeholder' | translate" autoGrow="true" formControlName="answer"></ion-textarea>
        </ion-item>
      </form>
    </div>
    <!-- Rating -->
    <div *ngSwitchCase="'rating'">
      <div class="superhuman__rating-options">
        <div
          class="superhuman__rating-item"
          *ngFor="let item of ratingArray"
          [class.superhuman__rating-item--active]="currentQuestion?.survey_customer_answer?.answer === item"
          (click)="selectAnswerRating(item)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <!-- Singlechoice -->
    <div *ngSwitchCase="'singlechoice'">
      <div
        class="superhuman__answers-options"
        [class.superhuman__answers-options--active]="currentQuestion?.survey_customer_answer?.answer === item.id"
        *ngFor="let item of currentQuestion.survey_answer_options"
        (click)="selectAnswerSinglechoice(item.id)"
      >
        {{ item.option_text }}
      </div>
    </div>
    <!-- Multichoice -->
    <div *ngSwitchCase="'multichoice'">
      <div
        class="superhuman__answers-options"
        [class.superhuman__answers-options--active]="currentQuestion?.survey_customer_answer?.answer?.includes(item.id)"
        *ngFor="let item of currentQuestion.survey_answer_options"
        (click)="selectAnswerMultichoice(item.id)"
      >
        {{ item.option_text }}
      </div>
    </div>
  </div>
</ion-content>
<ion-footer *ngIf="currentQuestion?.survey_customer_answer && !showThankYouMessage">
  <ion-button expand="block" mode="ios" (click)="submitAnswers()" [disabled]="currentQuestion.type === 'open' && freeTextFrom.invalid">
    {{'SHARED.actions.continue' | translate}}
  </ion-button>
  <ion-button
    *ngIf="currentQuestionDetails.previousQuestionID"
    [disabled]="currentQuestion.type === 'open' && freeTextFrom.invalid"
    expand="block"
    color="secondary"
    mode="ios"
    (click)="submitAnswersAndGoBack()"
  >
    {{'SHARED.actions.back' | translate}}
  </ion-button>
</ion-footer>
